import { useCallback, useContext, useEffect, useState } from "react"

//Context
import { UserContext } from "../../../context/userContext"

//Helpers
import { LoaderMedium } from "../../../components/Loaders"
import { LogError } from "../../../helpers/logger"

//Housing components
import OccupantDetail from "./OccupantDetail"
import { housingApiGetHousePastOccupationPost } from "../housingApi"

//PrimeReact
import { Paginator } from "primereact/paginator"
import { Dropdown } from "primereact/dropdown"

//Styles
import myStyles from "../../../styles/housing/HousingAllocations.module.css"

export default function ActiveRoomPastOccupantList({
  houseId,
  roomId,
  participants,
  participantsLoading,
}) {
  const userCtx = useContext(UserContext)

  const [isLoading, setIsLoading] = useState(true)
  const [pageSetup, setPageSetup] = useState({
    pageSize: 10,
    pageNum: 1,
    numTotal: 0,
    daysFilter: 30,
    systemSetup: false,
  })
  const [occupations, setOccupations] = useState([])

  const loadOccupants = useCallback(async () => {
    try {
      if (!pageSetup.systemSetup) {
        setIsLoading(true)
        const response = await housingApiGetHousePastOccupationPost(
          userCtx.tokenHousing,
          houseId,
          roomId,
          {
            pageSize: pageSetup.pageSize,
            pageNum: pageSetup.pageNum,
            period: pageSetup.daysFilter,
          }
        )

        setOccupations(response.bedOccupations || [])
        setPageSetup({
          ...pageSetup,
          pageSize: response.pageSize,
          pageNum: response.pageNum,
          numTotal: response.numTotal,
          systemSetup: true,
        })
        setIsLoading(false)
      }
    } catch (error) {
      LogError("Unable to load past occupants", error)
      setIsLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSetup])

  useEffect(() => {
    loadOccupants()
  }, [loadOccupants])

  let RenderDisplay = undefined

  if (isLoading) {
    RenderDisplay = <LoaderMedium />
  } else if (occupations && occupations?.length === 0) {
    RenderDisplay = <label>No past occupants found</label>
  } else if (occupations) {
    RenderDisplay = (
      <>
        {occupations.map((x) => (
          <>
            <OccupantDetail
              bedOccupancy={x}
              participant={participants?.find(
                (y) => y.participant_id === x.participantId
              )}
              participantsLoading={participantsLoading}
              showEdit={false}
            />{" "}
          </>
        ))}
        <Paginator
          first={pageSetup.pageSize * (pageSetup.pageNum - 1)}
          rows={pageSetup.pageSize}
          totalRecords={pageSetup.numTotal}
          onPageChange={(e) => {
            setPageSetup({
              ...pageSetup,
              pageNum: e.page + 1,
              systemSetup: false,
            })
          }}
        />
      </>
    )
  } else {
    RenderDisplay = <label>Unable to load past occupants</label>
  }

  return (
    <>
      <Dropdown
        options={[
          { value: 30, display: "30 days" },
          { value: 90, display: "90 days" },
          { value: 100, display: "180 days" },
          { value: 0, display: "All" },
        ]}
        optionValue={"value"}
        optionLabel={"display"}
        value={pageSetup?.daysFilter}
        onChange={(e) => {
          setPageSetup({
            ...pageSetup,
            daysFilter: e.value,
            systemSetup: false,
          })
        }}
        className={myStyles.pastOccupantDateRange}
      />
      {RenderDisplay}
    </>
  )
}
